<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <span class="header-text"><h4>{{$route.meta.pageTitle}}</h4></span>
        <a v-if="$route.name === 'payment-alert'" href="https://www.mongkolonline.com/link/worning.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การแจ้งเตือนชำระหนี้ (VDO)</a>
        <a v-if="$route.name === 'check'" href="https://www.mongkolonline.com/link/water_h.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การตรวจสอบค่าน้ำสูง  (VDO)</a>
        <a v-if="$route.name === 'report-p32'" href="https://www.mongkolonline.com/link/p32.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การพิมพ์รายงาน ป.32ประจำวัน  (VDO)</a>
        <a v-if="$route.name === 'report-p32'" href="https://www.mongkolonline.com/link/%E0%B8%9E%E0%B8%B4%E0%B8%A1%E0%B8%9E%E0%B9%8C%E0%B9%83%E0%B8%9A%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B9%87%E0%B8%882.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การพิมพ์ใบเสร็จจริง(สีฟ้า) ( VDO)</a>
        <a v-if="$route.name === 'meter'" href="https://www.youtube.com/watch?v=7GsnUAVc3EA" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การจดมิเตอร์ด้วย App บนมือถือ  (VDO)</a>
        <a v-if="$route.name === 'meter'" href="https://www.mongkolonline.com/link/jotmeter.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การจดมิเตอร์  (VDO)</a>
        <a v-if="$route.name === 'user'" href="https://www.mongkolonline.com/link/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9E%E0%B8%B4%E0%B9%88%E0%B8%A1%E0%B8%AA%E0%B8%A1%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%81.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การเพิ่มและยกเลิกสมาชิก  (VDO)</a>
        <a v-if="$route.name === 'payment'" href="https://www.mongkolonline.com/link/appslip.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การรับชำระเงินด้วย Appบนมือถือ (VDO)</a>
        <a v-if="$route.name === 'payment'" href="https://www.mongkolonline.com/link/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%8A%E0%B8%B3%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;"> การรับชำระเงินที่สำนักงาน (VDO)</a>
        <a v-if="$route.name === 'set-payment'" href="https://www.mongkolonline.com/link/%E0%B8%81%E0%B8%B3%E0%B8%AB%E0%B8%99%E0%B8%94%E0%B8%A3%E0%B8%AD%E0%B8%9A%E0%B8%AA%E0%B9%88%E0%B8%87%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การกำหนดรอบส่งเงิน (VDO)</a>
        <a v-if="$route.name === 'set-service'" href="https://www.mongkolonline.com/link/%E0%B8%AA%E0%B8%A3%E0%B8%B8%E0%B8%9B%E0%B8%82%E0%B8%B1%E0%B9%89%E0%B8%99%E0%B8%95%E0%B8%AD%E0%B8%99%E0%B8%97%E0%B8%B3%E0%B8%87%E0%B8%B2%E0%B8%99.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">สรุปขั้นตอนการใช้งานโปรแกรม (VDO)</a>
        <a v-if="$route.name === 'set-service'" href="https://www.mongkolonline.com/link/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B3%E0%B8%AB%E0%B8%99%E0%B8%94%E0%B8%A3%E0%B8%AD%E0%B8%9A.mp4" @click.prevent="openVDO($event)" style="margin-left: 10px; white-space: nowrap;">การกำหนดรอบบริการ(VDO)</a>

        <vs-spacer />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import ProfileDropDown      from "./components/ProfileDropDown.vue"

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    ProfileDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    openVDO(event) {
      const url = event.currentTarget.getAttribute('href');
      window.open(url, '_blank', 'width=800,height=600');
    }
  }
}
</script>
<style lang="scss">
  .header-text {
    padding-left: 15px;
  }
</style>

